import axios from "./axiosConfig";

// GET profile data
export const getFamilyTree = () => {
  return axios.get("/profile/family-tree/101");
};
